import * as React from 'react';
import { TableProps } from 'semantic-ui-react';
import '../css/table.sass';

export default function TD(props: TableProps) {
  const { className, ...other } = props; // eslint-disable-line @typescript-eslint/no-unused-vars
  const userClass = className ? `campfire-td ${className}` : 'campfire-td';
  return (
    <td className={userClass} {...other}>
      {props.children}
    </td>
  );
}
